import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { Subscription } from "rxjs/internal/Subscription";
import { PaymentService } from "../../../shared/services/payment.service";

@Component({
    selector: "app-mastercard-auth-page",
    templateUrl: "./mastercard-auth-page.component.html",
    styleUrls: ["./mastercard-auth-page.component.css"],
    standalone: false
})
export class MastercardAuthPageComponent implements OnInit {
  private route$: Subscription;
  transactionId: string;
  merchantId: string;
  orderId: string;
  sessionId: string;
  paymentDetails: any;
  isProcessing: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private payservice: PaymentService,
    private router: Router
  ) {
    this.transactionId = this.route.snapshot.params["id"];
  }

  ngOnInit() {
    this.orderId = sessionStorage.getItem("orderId");
    this.sessionId = sessionStorage.getItem("sessionId");
    this.paymentDetails = JSON.parse(sessionStorage.getItem("paymentDetails"));
    // this.merchantId = this.payservice.merchantId;
    // this.route$ = this.route.params.subscribe((params: Params) => {
    //   this.transactionId = params["id"];
    this.paymentTransaction();
    // });
  }

  paymentTransaction() {
    this.isProcessing = true;
    const paymentTransactionId = this.transactionId;
    const paymentBody = {
      apiOperation: "PAY",

      authentication: {
        transactionId: this.transactionId,
      },

      order: {
        amount: this.paymentDetails["amount"],
        currency: this.paymentDetails["currency"],
        reference: this.orderId,
      },
      sourceOfFunds: {
        type: "CARD",
      },

      session: {
        id: this.sessionId,
      },

      transaction: {
        reference: `pay_${this.transactionId}`,
      },
    };
    this.payservice.makePaymentTransaction(paymentBody).subscribe(
      (response) => {
        this.checkPaymentStatus();
      },
      (err) => {}
    );
  }

  checkPaymentStatus() {
    this.isProcessing = true;
    this.payservice
      .checkPaymentStatusForGhanaInnerFrame(
        this.paymentDetails["clientId"],
        this.paymentDetails["reference"]
      )
      .subscribe(
        (data) => {
          // this.setResponseMessage(data["status"]);
          this.isProcessing = false;
          this.processResponse(data["status"]);
        },
        (error) => {
          // this.route.navigate([
          //   `/failure/${this.ussdPaymentRequest.reference}/${error.error.responseMessage}`,
          // ]);
          this.isProcessing = false;

          // this.showStatus();
        }
      );
  }

  GA_paymentResponse;
  processResponse(status) {
    let GA_isw_response = document.getElementById("iswResponse");
    if (status == "ONGOING" || status == "CREATED") {
      this.GA_paymentResponse = `Transaction ${status}`;
      GA_isw_response.classList.add("errorReponse");
      setTimeout(function () {
        GA_isw_response.classList.remove("errorReponse");
      }, 3000);
      return;
    }
    if (status == "FAILED" || status == "ABANDONED") {
      // this.router.navigate([
      //   `/failure/${this.paymentDetails.amount}/${
      //     this.paymentDetails['reference']
      //   }/${btoa(this.paymentDetails.callbackURL)}`,
      // ]);
      window.top.location.href = `https://checkout.myrexpay.com/failure/${
        this.paymentDetails.amount
      }/${this.paymentDetails["reference"]}/${btoa(
        this.paymentDetails.callbackURL
      )}`;

      return;
    }

    if (status == "SUCCESS") {
      let callbackUrl = this.paymentDetails.callbackURL
        ? this.paymentDetails.callbackURL
        : "empty";
      // this.router.navigate([
      //   `/checkout/success/${this.paymentDetails.amount}/${
      //     this.paymentDetails['reference']
      //   }/${btoa(callbackUrl)}`,
      // ]);
      window.top.location.href = `https://checkout.myrexpay.com/checkout/success/${
        this.paymentDetails.amount
      }/${this.paymentDetails["reference"]}/${btoa(callbackUrl)}`;
      return;
    } else {
      // this.router.navigate([
      //   `/failure/${this.paymentDetails.amount}/${
      //     this.paymentDetails.referenceId
      //   }/${btoa(this.paymentDetails.callbackURL)}`,
      // ]);
      window.top.location.href = `https://checkout.myrexpay.com/failure/${
        this.paymentDetails.amount
      }/${this.paymentDetails["reference"]}/${btoa(
        this.paymentDetails.callbackURL
      )}`;
      return;
    }
  }
}
